<template>
  <div class="index-header">
    <v-logo v-if="!$store.state.isInIframe"></v-logo>
    <div v-else class="placeholder"></div>
    <el-input v-model="projectName" type="text"></el-input>
    <div class="operation-sets">
      <!-- <el-button type="default" size="mini">后台管理</el-button> -->

      <el-dialog
        title="发布"
        custom-class="publish-config-box"
        v-model="isShowPublishConfigBox"
        width="470px"
      >
        <div class="publish-config-item">
          <span class="publish-config-item-label">访问地址</span>
          <span class="publish-config-item-input">
            <el-input readonly spellcheck="false" v-model="PublishUrl"></el-input>
          </span>
          <span class="copy-url-btn">
            <el-button size="mini" type="primary" @click="copyPublishUrl">复制链接</el-button>
          </span>
        </div>
        <div class="publish-config-item">
          <span class="publish-config-item-label">开启密码</span>
          <span class="publish-config-item-selector">
            <el-radio v-model="isUsePassWord" label="0">关闭</el-radio>
            <el-radio v-model="isUsePassWord" label="1">开启</el-radio>
          </span>
        </div>
        <div class="publish-config-item" v-if="isUsePassWord === '1'">
          <span class="publish-config-item-label">设置密码</span>
          <span class="publish-config-item-input">
            <el-input
              spellcheck="false"
              v-model="publisVisitPassword"
              :type="isShowPassWord ? 'text' : 'password'"
            ></el-input>
          </span>
          <span class="toggle-show-my-password" @click="toggleShowPassword">
            <i :class="isShowPassWord ? 'el-icon-view' : 'iconfont icon-yanjing-guan'"></i>
          </span>
        </div>
        <template #footer>
          <span class="dialog-footer">
            <div v-if="!ProjectInfo.isPublished">
              <el-button size="mini" type="primary" @click="handlePublishProject">发布</el-button>
            </div>
            <div v-if="ProjectInfo.isPublished">
              <el-button size="mini" type="primary" @click="handleCancelPublishProject">取消发布</el-button>
              <el-button size="mini" type="primary" @click="handlePublishProject">重新发布</el-button>
            </div>
          </span>
        </template>
      </el-dialog>
      <el-button
        :class="{ 'btn-active': ProjectInfo.isPublished }"
        type="default"
        size="mini"
        @click="openPublishConfigBox"
        ><i class="el-icon-s-promotion"></i>
        {{ ProjectInfo.isPublished ? '已发布' : '未发布' }}
      </el-button>
      <el-button type="default" size="mini" @click="saveProject"
        ><i class="iconfont icon-save"></i>保存
      </el-button>
      <el-button type="default" size="mini" @click="handleNavigateToPreview">
        <i class="el-icon-view"></i>预览
      </el-button>
      <el-button type="default" size="mini" @click="handleNavigateToEixt"
        ><i class="iconfont icon-back"></i>返回</el-button
      >
    </div>
  </div>
</template>
<script>
import VLogo from '@/views/commonviews/VLogo.vue';
// @ is an alias to /src
import * as clipboardCopy from 'copy-to-clipboard';
import { mapState, mapMutations } from 'vuex';
import Api from '../../apis/api';
import { request } from '../../common/request';
export default {
  name: 'IndexHeader',
  components: { VLogo },
  props: {
    project_name: String,
  },
  data() {
    return {
      projectName: '',
      isShowPublishConfigBox: false,

      PublishUrl: 'www.tbdas.com',
      publisVisitPassword: '121212',
      isUsePassWord: '0',

      isShowPassWord: false,
      clipboard: null,
    };
  },
  watch: {
    ProjectPid: {
      deep: true,
      handler: function () {
        this.getPublishUrl();
      },
    },
    isShowPublishConfigBox(newVal) {
      if (newVal === false) {
        this.isShowPassWord = false;
      }
      this.getPublishUrl();
    },
    project_name: {
      deep: true,
      handler: function (val) {
        this.projectName = val;
      },
    },
    projectName(newVal) {
      this.set_ProjectInfo({
        Name: newVal,
      });
      // console.log(`ProjectName: ${this.$store.state.ProjectInfo.Name}`);
    },
    ProjectInfo: {
      deep: true,
      handler: function () {
        this.setCurrentData();
      },
    },
    currentSceneId: {
      deep: true,
      handler: function () {
        this.setCurrentData();
      },
    },
  },
  created() {
    this.setCurrentData();
    this.projectName = this.project_name;
  },
  mounted() {
    this.getPublishUrl();
  },
  computed: {
    ...mapState({
      ProjectPid: state => state.ProjectPid,
      ProjectInfo: state => state.ProjectInfo,
      currentSceneId: state => state.currentSceneId,
    }),
  },
  methods: {
    ...mapMutations(['set_ProjectInfo']),
    handleNavigateToEixt() {
      //window.localStorage.removeItem('origin_userInfo');
      window.localStorage.removeItem('project_row_id');
      //window.localStorage.setItem('logOut', 'yes');
      this.$router.push({ name: 'Manager' });
    },
    setCurrentData() {
      if (this?.ProjectInfo?.PublishConfig?.isUsePassWord) {
        this.isUsePassWord = this.ProjectInfo.PublishConfig.isUsePassWord;
      }
      if (this?.ProjectInfo?.PublishConfig?.PassWord) {
        this.publisVisitPassword = this.ProjectInfo.PublishConfig.PassWord;
      }
      if (this?.ProjectInfo?.PublishConfig?.PublishUrl) {
        this.PublishUrl = this.ProjectInfo.PublishConfig.PublishUrl;
      }
    },
    commitCurrentData() {
      this.set_ProjectInfo({
        PublishConfig: {
          isUsePassWord: this.isUsePassWord,
          PassWord: this.publisVisitPassword,
          PublishUrl: this.PublishUrl,
        },
      });
    },
    getPublishUrl() {
      let host = window.location.host;

      this.PublishUrl =
        'http://' + host + '/#/deploy?' + 'pid=' + this.ProjectPid + '&current=' + this.currentSceneId;
    },
    handleNavigateToPreview() {
      // 预览默认保存
      this.$store
        .dispatch('saveProject')
        .then(() => {
          // this.$ElMessage.success('数据保存成功！');
        })
        .catch(() => {
          // this.$ElMessage.error(`数据保存失败！${error}`);
        });
      this.$store.commit('del_CurrentConfigration');

      let routeUrl = this.$router.resolve({ name: 'Preview' });
      let newWindow = window.open(routeUrl.href, '_blank');
      // console.log(newWindow, 'newWindow');
      // this.$nextTick(() => {
      // newWindow.document.title = '00000';
      // alert('000', this.$store.state.ProjectInfo.Name);
      // });

      // document.title = '00000'
    },
    saveProject() {
      this.$store
        .dispatch('saveProject')
        .then(() => {
          this.$ElMessage.success('数据保存成功！');
        })
        .catch(error => {
          this.$ElMessage.error(`数据保存失败！${error}`);
        });
    },
    openPublishConfigBox() {
      this.isShowPublishConfigBox = true;
    },
    copyPublishUrl() {
      console.log(this.PublishUrl, '324242425525234');

      clipboardCopy(this.PublishUrl);
      this.$ElMessage.success('链接复制成功！');
    },
    toggleShowPassword() {
      this.isShowPassWord = !this.isShowPassWord;
    },
    handlePublishProject() {
      if (this.isUsePassWord === '1') {
        if (this.publisVisitPassword == null || this.publisVisitPassword.trim() === '') {
          this.$ElMessage.error(`密码格式不正确`);
          return;
        }
      }
      this.commitCurrentData();
      // let params = {
      //   method: 'post',
      //   url: Api.modifyProject_statues,
      //   data: {
      //     project_name: this.ProjectInfo.Name,
      //     config_data: JSON.stringify(this.ProjectInfo),
      //     dataId: this.$store.state.ProjectID,
      //     is_publish: '1',
      //     publish_url: this.PublishUrl,
      //     is_use_publish_password: this.isUsePassWord,
      //     publish_password: this.publisVisitPassword,
      //   },
      //   headers: {
      //     'content-type': 'application/json',
      //   },
      // };
      this.axios
        .post(Api.modifyProject_statues, {
          data: {
            project_name: this.ProjectInfo.Name,
            config_data: JSON.stringify(this.ProjectInfo),
            dataId: this.$store.state.ProjectID,
            is_publish: '1',
            publish_url: this.PublishUrl,
            is_use_publish_password: this.isUsePassWord,
            publish_password: this.publisVisitPassword,
          },
          headers: {
            'content-type': 'application/json',
          },
        })
        // request(params)
        .then(response => {
          this.$ElMessage.success('发布成功！');
          this.isShowPublishConfigBox = false;
          this.set_ProjectInfo({
            isPublished: true,
          });
        })
        .catch(err => {
          this.$ElMessage.error(`发布失败！ ${err}`);
        });
    },
    handleCancelPublishProject() {
      this.commitCurrentData();
      this.set_ProjectInfo({
        isPublished: false,
      });
      let params = {
        method: 'post',
        url: Api.modifyProject_statues,
        data: {
          project_name: this.ProjectInfo.Name,
          config_data: JSON.stringify(this.ProjectInfo),
          dataId: this.$store.state.ProjectID,
          is_publish: '0',
          publish_url: this.PublishUrl,
          is_use_publish_password: this.isUsePassWord,
          publish_password: this.publisVisitPassword,
        },
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
        },
      };
      request(params)
        .then(response => {
          console.log(response, '取消');
          this.$ElMessage.success('取消发布成功！');
          this.isShowPublishConfigBox = false;
        })
        .catch(err => {
          this.$ElMessage.error(`取消发布失败！ ${err}`);
          this.set_ProjectInfo({
            isPublished: true,
          });
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.index-header {
  user-select: none;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  .placeholder {
    width: 200px;
  }
  .btn-active {
    background: linear-gradient(143deg, #3651c5, #595dcb) !important;
    color: #eae9e9 !important;
  }

  :deep().publish-config-box {
    background-color: $background-color-medium;
    .publish-config-item {
      height: 30px;
      color: $font-color-base;
      margin-bottom: 12px;
      display: flex;
      align-items: center;
      .publish-config-item-label {
        width: 70px;
        margin-right: 0px;
      }
      .copy-url-btn {
        margin-left: 10px;
      }
      .toggle-show-my-password {
        margin-left: 10px;
        cursor: pointer;
      }

      .publish-config-item-selector {
        .el-radio__input.is-checked {
          .el-radio__inner {
            background: #3a52c4;
            border: 1px solid #759efe;
            &::after {
              background: #3a52c4;
            }
          }
        }
        .el-radio__inner {
          background: #676767;
          border: 1px solid #676767;
          &::after {
            background: #676767;
          }
        }
      }
    }
    .el-dialog__header {
      display: flex;
      justify-content: center;
      .el-dialog__title {
        color: $font-color-base;
        //font-weight: bold;
        letter-spacing: 2px;
        font-size: 20px;
      }
    }
    .el-dialog__footer {
      width: 100%;
      align-items: center;
      display: flex;
      text-align: center;
      .dialog-footer {
        width: 100%;
        .el-button {
          margin: 0 10px;
          width: 110px;
          background: linear-gradient(143deg, #3651c5, #595dcb);
          color: #eae9e9;
          &:hover {
            background: linear-gradient(143deg, #335ae9, #6f6ff5);
            color: white;
          }
        }
      }
    }
  }

  .el-input {
    width: 250px;
  }

  :deep().el-input input {
    height: 30px;
    color: #b6b8cc;
    background: #191b23;
    text-align: center;
    border: 1px solid rgba(139, 139, 139, 0.733);
    &:focus {
      border: 1px solid rgb(77, 91, 255);
    }
  }

  .operation-sets {
    padding-right: 5px;

    .el-button {
      // padding: 0 10px;
      border-radius: 5px;
      color: #b6b8cc;
      border: 0;
      background: #2c2e3f;

      &:hover {
        background: linear-gradient(143deg, #335ae9, #6f6ff5);
        color: white;
      }
    }

    .el-icon-s-promotion {
      padding-right: 4px;
    }

    .el-icon-switch-button {
      padding-right: 4px;
    }
    .el-icon-view {
      padding-right: 4px;
    }
    .icon-save {
      padding-right: 4px;
      font-size: 13px;
    }
    .icon-back {
      padding-right: 4px;
      font-size: 13px;
    }
  }
}
</style>
